import React from "react";
import Answers from "./Answers";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { encode } from 'js-base64';
import "../styles.scss"
import Translation from "../i18n";

class Question extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            finish: false,
            fetch: false,
            answered: false
        };
        this.setFinish = this.setFinish.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.setAnswered = this.setAnswered.bind(this);
    }

    setFinish() {
        this.setState({finish: true});
    }

    setAnswered() {
        this.setState({answered: true});
    }

    fetchData() {
        this.setState({fetch: true});
        console.log('fetch');

        const headers = new Headers();
        headers.append('Content-Type', 'application/json');

        const payload = {
            summary: this.props.summary
        }

        const summary = JSON.stringify(payload);
        const userdata = {
            username: localStorage.getItem('mm-name'),
            email: localStorage.getItem('mm-email'),
            lang: document.documentElement.lang
        };

        fetch("/questionnaire/api/create?questionnaireId=" + this.props.questionnaireId + '&userdata=' + JSON.stringify(userdata), {method: 'POST', headers: headers, body: summary})
            .then(response => {
                console.log(response.text());
                this.props.finish();
            })
            .catch(error => console.log('error', error));

    }

    render() {
        return (
            <>
                {this.state.fetch &&
                    <div className="fetch-progress">
                        <div className="fetch-progress-wrapper">
                            <div className="row align-items-center h-100">
                                <div className="col-12 text-center">
                                    <div className="fa-3x text-primary">
                                        <FontAwesomeIcon icon={fas.faSpinner} className="fa-spin" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                <div className={this.props.render ? 'd-block question' : 'd-none'} >
                    <>
                        <span className="question-text" dangerouslySetInnerHTML={{__html: this.props.question.text}} />
                        <span className="question-description" dangerouslySetInnerHTML={{__html: this.props.question.description}} />
                        <Answers {...this.props} setAnswered={() => this.setAnswered()} />
                    </>
                    {this.state.answered &&
                        <div className="row align-items-center">
                            <div className="col-12 text-center">
                                {this.props.questionPos !== this.props.questionsLength &&
                                    <button type="button" className="btn btn-secondary"
                                            onClick={this.props.nextQuestion}>
                                        <Translation i18n="next" />
                                    </button>
                                }
                                {this.props.questionPos === this.props.questionsLength &&
                                    <>
                                        <>
                                            {this.state.finish &&
                                                <span className="d-block mb-4 sure">
                                        <Translation i18n="sure" />
                                    </span>
                                            }
                                            {!this.state.finish &&
                                                <span className="d-block mb-4 sure"
                                                      dangerouslySetInnerHTML={{__html: '&nbsp;'}}/>
                                            }
                                        </>
                                        <button type="button" className="btn btn-secondary"
                                                onClick={this.state.finish ? this.fetchData : this.setFinish}>
                                            {this.state.finish &&
                                                <span>
                                                    <Translation i18n="imSure" />
                                                </span>
                                            }
                                            {!this.state.finish &&
                                                <span>
                                                    <Translation i18n="complete" />
                                                </span>
                                            }
                                        </button>
                                    </>
                                }
                            </div>
                        </div>
                    }
                </div>
            </>
        );
    }
}

export default Question;
